import {
  HttpClient,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddExpenseVatResponse,
  ExpenseVatCommonResponse,
  ExpenseVatItem,
  ExpenseVatResponse,
} from '@core/interface/expense-vat';
import { PagePayload } from '@core/interface/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ExpenseVatService {
  constructor(private http: HttpClient) {}

  getExpenseVats(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<ExpenseVatResponse>(
      environment.endPoints.expenseVatList,
      { params: httpParams }
    );
  }

  addExpenseVat(data: ExpenseVatItem) {
    return this.http.post<AddExpenseVatResponse>(
      environment.endPoints.expenseVatAddEdit,
      data
    );
  }

  deleteExpenseVat(id: number) {
    return this.http.get<ExpenseVatCommonResponse>(
      environment.endPoints.expenseVatDelete(id)
    );
  }
}
